export default "__VITE_ASSET__CtCA4j9h__"